import { useDateTimeFormat } from '@/components/Atoms/LocalizedDate/LocalizedDate';
import { sanitizeIcu } from '@/utils/dateUtils';
import type { FCl } from 'react-fc';

interface Props {
    startDate: string;
    endDate: string;
}

export const LocalizedDateRange: FCl<Props> = ({ startDate, endDate, className }) => {
    // typescript doesn't recognise `formatRange` on Intl.DateTimeFormat even though it exists, so I need to use <any>
    const dt: any = useDateTimeFormat();
    let dateString;
    if ('formatRange' in dt) {
        dateString = dt.formatRange(new Date(startDate), new Date(endDate));
    } else {
        dateString = dt.format(new Date(startDate)); // old browsers just show the start date
    }
    return (
        <time dateTime={startDate} className={className}>
            {sanitizeIcu(dateString)}
        </time>
    );
};
